import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login.vue'
import Home from '@/components/Home.vue'
import AddUser from '@/components/RegisterUser.vue'
import UserInfo from '@/components/UserInfo.vue'
import DeviceInfo from '@/components/DeviceInfo.vue'
import RegisterDevice from '@/components/RegisterDevice.vue'
import RegisterManager from '@/components/RegisterManager.vue'
import Welcome from '@/components/Welcome.vue'
import EditUserInfo from '@/components/EditUserInfo.vue'
import LanDeviceInfo from '@/components/LanDeviceInfo.vue'
import DeleteRegisterInfo from '@/components/DeleteRegisterInfo.vue'

// 1. 导入新增的两个组件（路径根据你的实际文件位置调整，确保正确）
import AppManager from '@/components/AppManager.vue' // 软件基础管理
import AppVersionManager from '@/components/AppVersionManager.vue' // 软件版本管理

Vue.use(Router)
const router=new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login,
      meta:{
        title:'系统登陆'
      }
    },
    {
      path: '/home',
      component: Home,
      meta:{
        title:'管理首页'
      },
      children:[
         {
          path: '',
          component: Welcome
        },
        {
          path: 'AddUser',
          component: AddUser,
          meta:{
            title:'添加用户'
          }
        },
        {
          path: 'UserInfo',
          component: UserInfo,
          meta:{
            title:'用户信息'
          }
        },
        {
          path: 'DeviceInfo',
          component: DeviceInfo,
          meta:{
            title:'在线设备'
          }
        },
        {
          path: 'LanDeviceInfo',
          component: LanDeviceInfo,
          meta:{
            title:'局域网设备'
          }
        },
        {
          path: 'RegisterDevice',
          component: RegisterDevice,
          meta:{
            title:'设备授权'
          }
        },
        {
          path: 'RegisterManager',
          component: RegisterManager,
          meta:{
            title:'授权设备管理'
          }
        },
        {
          path: 'Welcome',
          component: Welcome,
          meta:{
            title:'首页'
          }
        },
        {
          path: 'EditUserInfo',
          component: EditUserInfo,
          meta:{
            title:'用户中心'
          }
        },
        {
          path: 'DeleteRegisterInfo',
          component: DeleteRegisterInfo,
          meta:{
            title:'解除设备授权'
          }
        },
        // 2. 新增两个路由项（属于home的子路由，与其他功能平级）
        {
          path: 'AppManager',
          component: AppManager,
          meta:{
            title:'软件基础管理' // 配置页面标题，与原有格式一致
          }
        },
        {
          path: 'AppVersionManager',
          component: AppVersionManager,
          meta:{
            title:'软件版本管理' // 配置页面标题，与原有格式一致
          }
        }
      ]
    }
  ]
})

// 路由守卫权限控制（原有逻辑完全保留，无需修改）
router.beforeEach((to,from,next)=>{//beforeEach是router的钩子函数，在进入路由前执行
  let time=24 * 60 * 60 * 1000
  if(to.meta.title){//判断是否有标题
      document.title = to.meta.title
  }
  let token = JSON.parse(window.sessionStorage.getItem('token'));
	    if (token) {
			let deltime = new Date().getTime()
			if(deltime-token.time>time){
			    alert('登录已经过期，请重新登录')
			    window.sessionStorage.removeItem('token')
			     next('/login')
			}else{
        if(to.path == '/login'){
          next('/home')
        }else{
          next()
        }  
			}
			
	    } else {   // 若没有token，访问登录页面放行，其他的路由请求均拒绝，跳转到登录页
	    if (to.path == '/login') {
	            next()
	    } else {
	    if(from.path == '/'){
	                next('/login')
	    }else{
	                
                alert('请先登录！')
	                next('/login')
	    }
	            
	        }
	    }
})

export default router